import React from "react";
import { Box, Typography, Modal, Button } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import {
  BRAND_COLOR,
  BRAND_HOVER,
  useKivunovaTranslation
} from "@kivunova/kivufrontendcommon";
import type { DeletePurchaseOrderModalProps } from "../interfaces/modals";
import { deleteModalStyle } from "../constants/modalConstants";

const DeletePurchaseOrderModal: React.FC<DeletePurchaseOrderModalProps> = ({
  open,
  onClose,
  purchaseOrder
}) => {
  const { t } = useKivunovaTranslation();

  const handleDelete = () => {
    console.log(`Deleting purchase order: ${purchaseOrder.id}`);
    // TODO: implement API call when delete mutation is available
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={deleteModalStyle} color="black">
        <WarningAmberRoundedIcon color="warning" sx={{ fontSize: 48, mb: 2 }} />
        <Typography variant="h6" mb={1} fontSize={18}>
          {t(
            "delete-purchase-order-confirm-title",
            "Do you really want to delete this purchase order?"
          )}
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={2}>
          {t("delete-purchase-order-order-label", "Order:")}{" "}
          {purchaseOrder.documentNumber}
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          {t("delete-purchase-order-warning", "This action cannot be undone.")}
        </Typography>

        <Box display="flex" justifyContent="center" gap={2}>
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              backgroundColor: "white",
              color: BRAND_COLOR,
              "&:hover": {
                backgroundColor: BRAND_HOVER,
                opacity: 0.8,
                color: "white"
              },
              textTransform: "none"
            }}
          >
            {t("delete-purchase-order-cancel-button", "No")}
          </Button>
          <Button
            onClick={handleDelete}
            variant="contained"
            color="error"
            sx={{ textTransform: "none" }}
          >
            {t("delete-purchase-order-confirm-button", "Yes")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeletePurchaseOrderModal;
